import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {ObjectGroupViewModel} from "../system/admin-panel/ObjectGroupViewModel";
import { DriversViewModel} from "../system/admin-panel/Drivers/models/DriversViewModel";
import { map } from "rxjs/operators";
import { DriverPenaltyViewModel } from '../system/admin-panel/Drivers/models/DriverPenaltyViewModel';
import {Observable} from "rxjs";
import {DriverImportResultModel} from "../models/DriverImportResultModel";

@Injectable()
export class DriversService {

  constructor(private client: HttpClient) { }
  //////////////////////////////////////////////////////////////////
  public GetAllDrivers() {
    return this.client.get<any>("/ctrl/drivers").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(DriversViewModel.fromJS(item))
      }

      return result;
    }));
  }
  public DeleteObject(id) {
    return this.client.delete("/ctrl/drivers/" + id);
  }
  public updateDriver(driver: DriversViewModel) {
    return this.client.put("/ctrl/drivers", driver);
  }
  public createDriver(driver) {
    return this.client.post("/ctrl/drivers", driver);
  }


  //////////////////////////////////////////////////////////////////
  public GetGroups() {
    return this.client.get<any>("/ctrl/drivers/groups").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(ObjectGroupViewModel.fromJS(item))
      }
      return result;
    }));
  }

  importFromFile(file): Observable<DriverImportResultModel> {
    const formData = new FormData();
    formData.append('file', file);
    return this.client.post<DriverImportResultModel>('ctrl/DriverImport/import', formData)
      .pipe(map(data => {
        return DriverImportResultModel.fromJS(data);
      }));

  }

  public CreateGroup(input) {
    if(input.Id > 0)
      return this.client.put("/ctrl/drivers/groups", input);
    else
      return this.client.post("/ctrl/drivers/groups", input);
  }
  public DeleteGroup(input) {
    return this.client.delete("/ctrl/drivers/groups/" + input.Id);
  }
  //////////////////////////////////////////////////////////////////
  public updatePenalty(penalty) {
    return this.client.put("/ctrl/driverpenalties", penalty);
  }
  public GetPenalty() {
    return this.client.get<any>("/ctrl/driverpenalties").pipe(map(value => {
      return DriverPenaltyViewModel.fromJS(value);
    }));
  }
}
